const GOOGLE_ADS_ID = 'AW-717506291';
const ADS_PAYMENT_LABEL = 'DfUGCMDRpcgbEPONkdYC';
const ADS_SIGNUP_LABEL ='tVC9CKGNpsgbEPONkdYC';

// const sendEvent = (eventName, params = {}) => {
//   if (typeof window !== 'undefined') {
//     if (typeof window.gtag === 'function') {
//       window.gtag('event', eventName, params);
//     } else if (Array.isArray(window.dataLayer)) {
//       window.dataLayer.push({
//         event: eventName,
//         ...params,
//       });
//     }
//   }
// };

const waitForGtag = (callback, retries = 10) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    callback();
  } else if (retries > 0) {
    setTimeout(() => waitForGtag(callback, retries - 1), 300);
  } else {
    console.warn('gtag non chargé, conversion non envoyée');
  }
};

// export const trackSignup = (method = 'email') => {
//   sendEvent('sign_up', {
//     method,
//   });
//   if (ADS_SIGNUP_LABEL && GOOGLE_ADS_ID) {
//     sendEvent('conversion', {
//       send_to: `${GOOGLE_ADS_ID}/${ADS_SIGNUP_LABEL}`,
//     });
//   }
// };

export const trackSignup = () => {
  waitForGtag(() => {
    window.gtag('event', 'conversion', {
      send_to: `${GOOGLE_ADS_ID}/${ADS_SIGNUP_LABEL}`,
    });
  });
};

// export const trackPaymentIntent = ({ planName = 'unknown', priceId = '', currency = 'EUR', value = 0 }) => {
//   sendEvent('begin_checkout', {
//     items: [{ item_name: planName, price_id: priceId }],
//     currency,
//     value,
//   });
// };

// export const trackPaymentConversion = ({ value = 0, currency = 'EUR' } = {}) => {
//   if (!ADS_PAYMENT_LABEL || !GOOGLE_ADS_ID) {
//     return;
//   }
//   sendEvent('conversion', {
//     send_to: `${GOOGLE_ADS_ID}/${ADS_PAYMENT_LABEL}`,
//     value,
//     currency,
//   });
// };

export const trackPaymentConversion = ({ value = 0, currency = 'EUR' } = {}) => {
  waitForGtag(() => {
    window.gtag('event', 'conversion', {
      send_to: `${GOOGLE_ADS_ID}/${ADS_PAYMENT_LABEL}`,
      value,
      currency,
    });
  });
};